@if (product) {
<div class="content">
  <app-product-images-carousel [images]="product.images"></app-product-images-carousel>
  <div class="info">
    <app-product-location [product]="product"></app-product-location>
    <h1>{{product.name}}</h1>
    <div class="shipping">
      <span style="text-decoration: underline"
        matTooltip="Free shipping on orders ${{free_shipping_threshold}}+">Shipping</span>
      calculated at checkout.
    </div>
    <div class="delivery">
      <mat-icon fontSet="material-symbols-outlined">delivery_truck_speed</mat-icon>
      <span>Estimated delivery: {{deliveryDate}}</span>
    </div>
    @for (attr of product.attrs; track $index) {
    <app-product-attr-value-select [attr]="attr" [activeValue]="attrs[$index]"
      (activeValueChange)="selectAttr($index,$event)"></app-product-attr-value-select>
    }
    <app-product-attr-value-select [attr]="product.priced_attr" [activeValue]="pricedAttrValue"
      (activeValueChange)="selectPricedAttr($event)">
      @if (product.priced_attr.name==='Size' &&
      product.size_table.titles.length>0) {
      <app-product-size-table-button [data]="product.size_table"></app-product-size-table-button>
      }
    </app-product-attr-value-select>

    @if(is_authenticated){
    <span class="price">
      ${{pricedAttrValue?.price|number}}
    </span>
    <div class="add_to_cart">
      <app-add-to-cart-button [product_id]="product.id" [product_attr_values]="attrs"
        [product_priced_attr_value]="pricedAttrValue"></app-add-to-cart-button>

      <div class="extra">
        <span> <mat-icon fontSet="material-symbols-outlined" inline>package_2</mat-icon>Free shipping over
          ${{free_shipping_threshold}}</span>
        <div class="divider"></div>
        <span><mat-icon fontSet="material-symbols-outlined" inline>cycle</mat-icon>30-day returns</span>
      </div>
    </div>
    }@else{
    <app-unlock-product-price-card></app-unlock-product-price-card>
    }
    <div class="descriptions">
      <app-product-descriptions [descriptions]="product.descriptions"></app-product-descriptions>
    </div>
  </div>
</div>

<app-product-recommended-list [no]="product.no"></app-product-recommended-list>
}